import { FC, ReactNode } from 'react';
import { Box, useTheme } from '@mui/material';

interface Props {
  children: ReactNode;
}

const ReviewContent: FC<Props> = ({ children }) => {
  const theme = useTheme();
  return <Box sx={{ p: theme.spacing(2) }}>{children}</Box>;
};

export default ReviewContent;
